import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigation } from "@refinedev/core";
import { Button } from "antd";

export const ButtonBackToListing = () => {
  const { push } = useNavigation();
  return (
    <Button type="text" size="small" onClick={() => push("/explorations")}>
      <ArrowLeftOutlined />
    </Button>
  );
};
